import styled from "styled-components";
export const Container = styled.div`
  padding: 0px;
`;

export const Logo = styled.div`
  display: block;
  float: left;
  text-decoration: none;
  line-height: normal;

  & > span {
    font-family: "RockSalt";
    padding: 0 10px;
    font-size: 1.5em;
    color: var(--primary);

    @media (max-width: 950px) {
      font-size: 1em;
    }

    &:hover {
      transition: all 0.5s ease-out;
      color: var(--secondary);
      text-decoration: none;
    }
  }
`;
export const Nav = styled.nav`
  max-width: 1128px;
  margin: auto;
  padding: 12px 0 10px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 1100px) {
    /* margin: 0px 30px; */
  }
`;

export const NavRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  position: relative;
  flex-wrap: nowrap;

  @media (max-width: 950px) {
    display: none;
  }
`;

export const NavColumn = styled.div`
  display: flex;

  flex-direction: column;
  line-height: 40px;
  @media (min-width: 950px) {
    margin: 0px 25px;
  }
  @media (min-width: 950px) {
    display: none;
  }
`;

export const MenuIcon = styled.a`
  visibility: hidden;
  padding: 10px;
  border-radius: 4px;
  @media (min-width: 950px) {
    display: none;
  }
  @media (max-width: 950px) {
    visibility: visible;
  }

  & > img {
    height: 15px;
    width: 15px;
    fill: var(--secondary);
  }
  &:hover {
    background-color: var(--hoverback);
    text-decoration: none;
  }
`;

export const NavBtn = styled.a`
  font-size: 16px;
  padding: 10px 12px;
  text-decoration: none;
  color: var(--secondary);
  margin-right: 12px;
  border-radius: 4px;

  @media (max-width: 950px) {
    display: flex;
  }
  &:hover {
    transition: all 0.3s ease-out;
    background-color: var(--hoverback);
    color: var(--primary);
    text-decoration: none;
  }
`;
